import { render, staticRenderFns } from "./OrgAdminManageLandingPage.vue?vue&type=template&id=1cb59806&scoped=true&"
import script from "./OrgAdminManageLandingPage.vue?vue&type=script&lang=ts&"
export * from "./OrgAdminManageLandingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb59806",
  null
  
)

export default component.exports